import { Plan } from '@mnz/builder';

export const planPriceButtonText = (plan: Plan) => {
    return `$${plan.PRICE}USD/${plan.INTERVAL}`;
};
